export default __webpack_public_path__ + "static/media/purple_necklace.716de143.png";